import { MutableRefObject } from 'react';
import GameEngine from 'react-game-engine';

import { Dim, Entity } from '../../models';
import InputPad from '../renderers/InputPad';
import { Settings } from '../../../../../../models';
import events from '../../../../events';
import { getPanelDims } from '../../helpers';
import { INPUT_MODES } from '../../../../../../constants/defaults';

export default (
  windowDims: Dim,
  settings: Settings,
  gameEngineRef: MutableRefObject<GameEngine>
): Entity => {
  const jogging = settings.inputMode === INPUT_MODES.jog;
  const panelDims =
    getPanelDims(windowDims)[jogging ? INPUT_MODES.jog : INPUT_MODES.gym];
  const panelS = 2 * (panelDims.b ?? 0) + 2 * (panelDims.m ?? 0);
  const spacedWidth = panelDims.w + panelS;
  const spacedHeight = panelDims.h + panelS;
  const padWidth = (jogging ? 1 : 3) * spacedWidth;
  const padHeight = (jogging ? 1 : 4) * spacedHeight;
  const keyModeCallback = (label) =>
    gameEngineRef.current?.dispatch(events.onKeyDown(label.key));
  const padModeCallback = (label) =>
    gameEngineRef.current?.dispatch(events.onInputPadSend(label));
  const callback =
    settings.inputMode === INPUT_MODES.key ? keyModeCallback : padModeCallback;

  return {
    dims: { w: padWidth, h: padHeight },
    getPos: () => ({
      x: windowDims.w / 2,
      y: windowDims.h - spacedHeight - padHeight / 2,
    }),
    panelDims,
    inputMode: settings.inputMode,
    whichPadLabels: settings.whichPadLabels,
    targetLabel: settings.homework?.problems[0]?.answers[0],
    guidance: settings.guidance,
    callback,
    renderer: InputPad,
  };
};
